import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '../buttons/buttons.module';
import { DrawerComponent } from './drawer.component';
import { DrawerExampleComponent } from './story/drawer-example.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { PortalModule } from '@angular/cdk/portal';
import { DrawerContentExampleComponent } from './story/examples/drawer-content-example.component';
import { DrawerTableExampleComponent } from './story/examples/drawer-table-example.component';
import { DrawerFormExampleComponent } from './story/examples/drawer-form-example.component';
import { SharedModule } from '@app/shared/shared.module';
import { DirectiveModule } from '@app/shared/directives/directive.module';
import { DataGridService } from '../cm-data-grid/cm-data-grid.service';

@NgModule({
  declarations: [
    DrawerComponent,
    DrawerExampleComponent,
    DrawerContentExampleComponent,
    DrawerTableExampleComponent,
    DrawerFormExampleComponent,
  ],
  imports: [
    CommonModule,
    MaterialsModule,
    ButtonsModule,
    MatBottomSheetModule,
    TranslateModule.forChild(),
    PortalModule,
    DirectiveModule,
  ],
  exports: [DrawerComponent],
  providers: [DataGridService],
})
export class DrawerModule {}
